// extracted by mini-css-extract-plugin
module.exports = {"profile":"delegateDropdown_profile__AuWNr"};